import React from 'react';
export function ArrowDownIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.761 11.251a1 1 0 00-1.414 0l-5.371 5.355.016-11.586a1 1 0 00-2 0l-.016 11.58-5.357-5.37A1.001 1.001 0 004.2 12.643l7.061 7.081a1 1 0 001.413.002l7.081-7.06a1 1 0 00.006-1.415z"
  }));
}